<template>
  <div id="navigation">
    <div
      id="outer"
      ref="outer"
      :class="{'show-product': showProduct}"
      :style="[{top:top+'px'}]"
      @mouseleave="showProduct = false;showCode = false"
    >
      <div
        id="inner"
        :class="{'hidden': hidden}"
      >
        <div
          id="left"
          class="flex-vertical links"
        >
          <img
            id="desktop-logo"
            src="@/assets/logo.png"
            @mouseover="showProduct = false"
            @click="$router.push('/')"
          >
          <img
            id="mobile-logo"
            src="@/assets/mobile-logo@2x.png"
            @mouseover="showProduct = false"
            @click="$router.push('/')"
          >
          <div>
            <span @mouseover="showProduct = true">
              <a>产品</a>
            </span>
            <span @mouseover="showProduct = false">
              <router-link to="/artist">艺人</router-link>
            </span>
            <span @mouseover="showProduct = false">
              <router-link to="/about">简介</router-link>
            </span>
            <span @mouseover="showProduct = false">
              <router-link to="/support">服务</router-link>
            </span>
            <span @mouseover="showProduct = false">
              <a
                v-if="!loggedIn"
                @click="toggleLoginWindow"
              >
                激活码
              </a>
              <router-link
                v-else
                to="/redeem"
              >
                激活码
              </router-link>
            </span>
            <!-- <span @mouseover="showProduct = false">
              <router-link to="/help-center">帮助中心</router-link>
            </span> -->
            <span @mouseover="showProduct = false">
              <a href="https://www.positivegrid.com">前往国际版</a>
            </span>
            <span @mouseover="showCode = true">
              <a>联系我们</a>
            </span>
          </div>
        </div>
        <div
          id="right"
          class="flex-vertical"
          @mouseover="showProduct = false"
        >
          <div v-if="!loggedIn">
            <img
              src="@/assets/icons/btn-login.png"
              style="height:21px;width:19px;"
              @click="toggleLoginWindow"
            >
          </div>
          <div v-else>
            <div class="relative w-8 h-8 text-center bg-gray-200 rounded-full">
              <span
                class="leading-8 text-black cursor-pointer"
                @click="toggleUserMenu"
              >{{ tokenInfo.last_name ? tokenInfo.last_name.charAt(0) : '匿' }}</span>
              <div
                v-if="showUserMenu"
                class="absolute right-0 flex flex-col items-center py-5 bg-gray-900 shadow-md user-menu"
              >
                <div class="flex flex-col items-center flex-1">
                  <div class="flex items-center justify-center w-20 h-20 mb-4 bg-gray-200 rounded-full">
                    <span class="text-5xl text-black leading-16">{{ tokenInfo.last_name ? tokenInfo.last_name.charAt(0) : '匿' }}</span>
                  </div>
                  <span class="mb-1 text-xl font-bold">{{ tokenInfo.last_name }} {{ tokenInfo.first_name }}</span>
                  <span class="text-sm">{{ tokenInfo.email }}</span>
                </div>
                <router-link
                  class="block w-full py-3 mb-5 border-t border-b border-gray-700 cursor-pointer"
                  to="/download"
                >
                  我的购买纪录
                </router-link>
                <button @click="logout">
                  登出
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          id="right-mobile"
          class="flex-vertical links"
        >
          <span
            :id="!showMobileMenu ? 'menu-icon' : 'menu-close-icon'"
            @click="showMobileMenu = !showMobileMenu"
          />
        </div>
      </div>
      <div
        v-if="showProduct"
        class="product-menu"
      >
        <div>
          <h4>电脑版</h4>
          <div>
            <router-link to="/bias-fx2">
              <div id="product-fx2-pc">
                <div class="icon" />
                <p>
                  BIAS
                  <span>FX 2</span>
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <div>
          <h4>移动版</h4>
          <div>
            <router-link to="/bias-fx-mobile">
              <div id="product-fx2-mobile">
                <div class="icon" />
                <p>
                  BIAS
                  <span>FX</span>
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <div>
          <h4>街演音箱</h4>
          <div>
            <router-link to="/spark-edge">
              <div id="product-spark-edge">
                <div class="icon" />
                <p>
                  Spark
                  <span>EDGE</span>
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <!-- <div>
          <h4>放大器</h4>
          <div>
            <router-link to="/bias-mini-guitar">
              <div id="product-mini-guitar">
                <div class="icon" />
                <p>
                  BIAS MINI
                  <span>Guitar</span>
                </p>
              </div>
            </router-link>
          </div>
        </div> -->
        <div>
          <h4>智能音箱</h4>
          <div>
            <router-link to="/spark-go">
              <div id="product-mini-spark-go">
                <div class="icon" />
                <p>
                  Spark GO
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <div>
          <h4>智能音箱</h4>
          <div>
            <router-link to="/spark-mini">
              <div id="product-mini-spark-mini">
                <div class="icon" />
                <p>
                  Spark MINI
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <div>
          <h4>演出音箱</h4>
          <div>
            <router-link to="/spark-live">
              <div id="product-spark-live">
                <div class="icon" />
                <p>
                  Spark LIVE
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <div>
          <h4>无线静音耳机</h4>
          <div>
            <router-link to="/spark-neo">
              <div id="product-spark-neo">
                <div class="icon" />
                <p>
                  Spark NEO
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <div>
          <h4>智能音箱</h4>
          <div>
            <router-link to="/spark40">
              <div id="product-mini-spark">
                <div class="icon" />
                <p>
                  Spark40
                </p>
              </div>
            </router-link>
          </div>
        </div>
        <div>
          <h4>AI智能音箱</h4>
          <div>
            <router-link to="/spark2">
              <div id="product-mini-spark2">
                <div class="icon" />
                <p>
                  Spark2
                </p>
              </div>
            </router-link>
          </div>
        </div>

        <div>
          <h4>多功能声卡</h4>
          <div>
            <router-link to="/riff_interface">
              <div id="riff_mini">
                <div class="icon" />
                <p>
                  RIFF
                </p>
                <p>
                  <span>interface</span>
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div
        v-if="showCode"
        class="product-menu product-menu_code"
      >
        <div>
          <h4>&nbsp;</h4>
          <div>
            <router-link to="/bias-fx2">
              <div id="code">
                <div class="icon" />
                <p>
                                    &nbsp;
                  <span>&nbsp;</span>
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div
        v-if="showMobileMenu"
        class="mobile-menu"
      >
        <h4>产品</h4>
        <p @click="showMobileMenuDesktop = !showMobileMenuDesktop">
          电脑版
          <span
            v-if="showMobileMenuDesktop"
            class="menu menu-open"
          />
          <span
            v-else
            class="menu menu-close"
          />
        </p>
        <router-link
          v-if="showMobileMenuDesktop"
          class="mobile-menu-link"
          to="/bias-fx2"
          @click="showMobileMenu = false"
        >
          BIAS FX 2
        </router-link>
        <p @click="showMobileMenuMobile = !showMobileMenuMobile">
          移动版
          <span
            v-if="showMobileMenuMobile"
            class="menu menu-open"
          />
          <span
            v-else
            class="menu menu-close"
          />
        </p>
        <router-link
          v-if="showMobileMenuMobile"
          class="mobile-menu-link"
          to="/bias-fx-mobile"
          @click="showMobileMenu = false"
        >
          BIAS FX
        </router-link>
        <!-- <p @click="showMobileMenuMobile = false; showMobileMenuDesktop = false; showMobileMenuAmp = !showMobileMenuAmp">
          放大器
          <span
            v-if="showMobileMenuAmp"
            class="menu menu-open"
          />
          <span
            v-else
            class="menu menu-close"
          />
        </p>
        <router-link
          v-if="showMobileMenuAmp"
          class="mobile-menu-link"
          to="/bias-mini-guitar"
          @click="showMobileMenu = false"
        >
          BIAS MINI Guitar
        </router-link> -->
        <p @click="showSpark = !showSpark">
          智能音箱
          <span
            v-if="showSpark"
            class="menu menu-open"
          />
          <span
            v-else
            class="menu menu-close"
          />
        </p>

        <router-link
          v-if="showSpark"
          class="mobile-menu-link"
          to="/spark-go"
          @click="showMobileMenu = false"
        >
          Spark GO
        </router-link>
        <router-link
          v-if="showSpark"
          class="mobile-menu-link"
          to="/spark-mini"
          @click="showMobileMenu = false"
        >
          Spark MINI
        </router-link>
        <router-link
          v-if="showSpark"
          class="mobile-menu-link"
          to="/spark-live"
          @click="showMobileMenu = false"
        >
          Spark LIVE
        </router-link>
        <router-link
          v-if="showSpark"
          class="mobile-menu-link"
          to="/spark40"
          @click="showMobileMenu = false"
        >
          Spark40
        </router-link>
        <router-link
          v-if="showSpark"
          class="mobile-menu-link"
          to="/spark2"
          @click="showMobileMenu = false"
        >
          Spark2
        </router-link>
        <router-link
          v-if="showSpark"
          class="mobile-menu-link"
          to="/spark-neo"
          @click="showMobileMenu = false"
        >
          Spark NEO
        </router-link>
        <router-link
          v-if="showSpark"
          class="mobile-menu-link"
          to="/spark-edge"
          @click="showMobileMenu = false"
        >
          Spark EDGE
        </router-link>
        <p @click="showRiff = !showRiff">
          多功能声卡
          <span
            v-if="showRiff"
            class="menu menu-open"
          />
          <span
            v-else
            class="menu menu-close"
          />
        </p>
        <router-link
          v-if="showRiff"
          class="mobile-menu-link"
          to="/riff_interface"
          @click="showMobileMenu = false"
        >
          RIFF interface
        </router-link>
        <hr>
        <div>
          <router-link
            to="/artist"
            @click="showMobileMenu = false"
          >
            艺人
          </router-link>
          <router-link
            to="/about"
            @click="showMobileMenu = false"
          >
            简介
          </router-link>
          <router-link to="/support">
            服务
          </router-link>
          <router-link to="/download">
            下载
          </router-link>
          <div>
            <a
              v-if="!loggedIn"
              @click="toggleLoginWindow"
            >
              激活码
            </a>
            <router-link
              v-else
              to="/redeem"
            >
              激活码
            </router-link>
          </div>
          <!-- <router-link to="/help-center">
            帮助中心
          </router-link> -->
          <div>
            <a href="https://www.positivegrid.com">前往国际版</a>
          </div>
          <div v-if="!loggedIn">
            <a @click="toggleLoginWindow">登录</a>
          </div>
          <div v-else>
            <a
              href
              @click="logout"
            >登出</a>
            <a @click="showMobileMenu = false">{{ tokenInfo.last_name }} {{ tokenInfo.first_name }} 您好</a>
          </div>
        </div>
      </div>
      <div
        v-if="$route.name == 'Spark'"
        class="spark_inner"
      >
        <div class="icon">
          <img
            src="~@/assets/newSpark/logotype_spark.svg"
            alt=""
          >
        </div>
        <div class="content">
          <span>概述</span>
          <span @click="$router.push('/help-center')">帮助中心</span>
          <!-- <p
            id="toTaobao"
          >
            关注微信公众号
          </p> -->
        </div>
      </div>
    </div>
    <login-window
      v-if="showLoginWindow"
      :token="token"
      @close="toggleLoginWindow"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import store from '@/store'
import urls from '@/urls'
import jwtDecode from 'jwt-decode'
import LoginWindow from '@/components/login-window'
export default {
  store,
  components: {
    LoginWindow
  },
  props: {
    withBiasBanner: {
      type: Boolean,
      default: false
    },
    // top scroll
    top: {
      type: [Number],
      default: 42
    }
  },
  data () {
    return {
      hidden: false,
      showProduct: false,
      showCode: false,
      showMobileMenu: false,
      showMobileMenuMobile: false,
      showMobileMenuDesktop: false,
      showMobileMenuAmp: false,
      showSpark: false,
      showRiff: false,
      prevScroll: 0,
      showLoginWindow: false,
      showUserMenu: false,
      token: ''
    }
  },
  watch: {
    showProduct (val) {
      if (val) {
        this.showCode = false
      }
    },
    showCode (val) {
      if (val) {
        this.showProduct = false
      }
    }
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    loginUrl () {
      const result = new URL(`${urls.USER_CENTER_URL}/store_auth`)
      result.searchParams.set('redirect_to', '/')
      result.searchParams.set(
        'redirect_host',
        `${window.location.toString()}?login=`
      )
      result.searchParams.set('back_to', '/')
      return result
    },
    signupUrl () {
      const result = new URL(`${urls.USER_CENTER_URL}/store_signup`)
      result.searchParams.set('redirect_to', '/')
      result.searchParams.set(
        'redirect_host',
        `${window.location.toString()}?login=`
      )
      result.searchParams.set('back_to', '/')
      return result
    },
    ...mapState('Auth', {
      loggedIn: 'loggedIn',
      tokenInfo: 'info'
    })
  },
  mounted: function () {
    this.loadPageFormResetPassword()
    // if (!this.withBiasBanner) {
    window.addEventListener('scroll', this.handleScroll)
    // }
    const pgToken = this.hasLoginToken()
    if (pgToken) {
      this.setLoginToken(pgToken)
    }
  },
  methods: {
    toTaobaoFun () {
      window.open(
        'https://item.taobao.com/item.htm?spm=a2oq0.12575281.0.0.353c1debCzShxX&ft=t&id=622016680358'
      )
    },
    handleScroll (e) {
      const yOffset = window.pageYOffset
      if (this.prevScroll > yOffset) {
        this.hidden = false
      } else {
        this.hidden = true
      }
      if (yOffset === 0) {
        this.hidden = false
      }
      this.prevScroll = yOffset
    },
    logout () {
      this.showMobileMenu = false
      window.localStorage.removeItem('PG_TOKEN')
      window.localStorage.removeItem('PG_EMAIL')
      this.storeLogout()
      this.showUserMenu = false
    },
    ...mapMutations('Auth', {
      storeLogin: 'LOGIN',
      storeLogout: 'LOGOUT'
    }),
    hasLoginToken () {
      let qs = this.$route.query['login']
      let localStorageToken = window.localStorage.getItem('PG_TOKEN')
      if (qs) {
        return jwtDecode(qs.split('/')[3])['redirect_to'].split('=')[1]
      } else if (this.$route.query['app_user_token']) {
        return this.$route.query['app_user_token']
      } else if (localStorageToken) {
        return localStorageToken
      }
    },
    setLoginToken (token) {
      window.localStorage.setItem('PG_TOKEN', token)
      const decoded = jwtDecode(token)
      this.storeLogin({
        token,
        info: decoded
      })
    },
    toggleLoginWindow () {
      this.showMobileMenu = false
      const body = document.body
      this.showLoginWindow = !this.showLoginWindow
      this.showLoginWindow
        ? body.classList.add('modal-open')
        : body.classList.remove('modal-open')
    },
    toggleUserMenu () {
      this.showUserMenu = !this.showUserMenu
    },
    loadPageFormResetPassword () {
      const url = new URL(window.location.href)
      const token = url.searchParams.get('tk')

      if (token) {
        this.token = token
        this.toggleLoginWindow()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden {
    top: -54px !important;
    transition: top 0.5s;
}
.spark_inner {
    height: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 66px 0 54px;
    opacity: 0.9;
    background-color: black;
    @media only screen and (max-width: 768px) {
        padding: 0 10px;
    }
    .icon {
        @media only screen and (max-width: 768px) {
            padding-right: 20px;
            border-right: 1px solid #fff;
            margin-right: 20px;
        }
        img {
            width: 64px;
            height: 20px;
        }
    }
    .content {
        display: flex;
        color: #fff;
        span {
            margin-right: 30px;
            font-weight: normal;
            font-size: 14px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            @media only screen and (max-width: 768px) {
                margin-right: 20px;
            }
        }
        p {
            padding: 5px 12px;
            background: #e02020;
            border-radius: 2px;
            font-size: 14px;
            cursor: pointer;
        }
    }
}
div#outer {
    top: 42px;
    position: fixed;
    z-index: 10;
    // opacity: 0.9;
    // background-color: black;
    width: 100%;
    transition: top 0.5s;
}
div#outer.show-product {
    z-index: 11;
}

div#inner {
    top: 0;
    height: 54px;
    background: #000;
    opacity: 1;
}

a:visited {
    color: #d7d7d7;
}

img {
    width: 131px;
    height: 31px;
    cursor: pointer;
}

a {
    text-decoration: none;
}

.links > div {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.links {
    a {
        padding: 0;
        margin-left: 28px;
    }
}

a {
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    color: #d7d7d7;
}

#right {
    float: right;
}

a {
    text-decoration: none;
}

#left {
    float: left;
    height: 100%;
    padding-left: 50px;
}

#right {
    float: right;
    height: 100%;
    padding-right: 50px;
}
.product-menu {
    color: white;
    position: fixed;
    z-index: 1;
    width: 100%;
    background-color: black;
}
.product-menu h4 {
    font-size: 15px;
    font-weight: 600;
}
.product-menu > div p {
    font-size: 15px;
    font-weight: bold;
}
.product-menu > div p > span {
    font-weight: 300;
}
.product-menu .icon {
    width: 105px;
    height: 110px;
    background-size: cover;
}
.product-menu_code .icon {
    width: 210px;
    height: 200px;
    background-size: cover;
}
.product-menu #product-fx2-mobile > div {
    background-image: url(../assets/product-menu/fx-copy@2x.png);
}
.product-menu #product-mini-guitar > div {
    background-image: url(../assets/product-menu/mini-guitar@2x.png);
}
.product-menu #product-mini-spark > div {
    background-image: url(../assets/product-menu/spark.png);
}
.product-menu #product-mini-spark-mini > div {
    background-image: url(../assets/product-menu/spark-mini.jpg);
}
.product-menu #product-spark-live > div {
    background-image: url(../assets/product-menu/spark-live.png);
}
.product-menu #product-spark-neo > div {
    background-image: url(../assets/product-menu/spark-neo.png);
}
.product-menu #product-spark-edge > div {
    background-image: url(../assets/product-menu/spark-edge.png);
}
.product-menu #product-mini-spark-go > div {
    background-image: url(../assets/product-menu/spark-go.png);
}
.product-menu #product-mini-spark2 > div {
    background-image: url(../assets/product-menu/spark2.png);
}
.product-menu #riff_mini > div {
    background-image: url(../assets/riff/riff_mini.png);
}

.product-menu #product-amp2-mobile > div {
    background-image: url(../assets/product-menu/amp-copy@2x.png);
}
.product-menu #product-fx2-pc > div {
    background-image: url(../assets/product-menu/fx@2x.png);
}
.product-menu #code > div {
    background-image: url(../assets/product-menu/wx_code.png);
}
.product-menu #product-amp2-pc > div {
    background-image: url(../assets/product-menu/amp@2x.png);
}
.product-menu > div:first-of-type {
    margin-left: 209px;
}
.product-menu > div {
    margin-left: 2%;
    display: inline-block;
}

.product-menu > div > div {
    display: flex;
}
.product-menu > div > div > a {
    margin-right: 2%;
    text-align: left;
}
#mobile-logo {
    display: none;
}
#right-mobile {
    display: none;
}

@media screen and (max-width: 768px) {
    div#inner {
        height: 44px;
    }
    #mobile-logo {
        display: block;
        object-fit: contain;
    }
    #left {
        padding-left: 2.5%;
    }
    #desktop-logo {
        display: none;
    }
    #left div {
        display: none;
    }
    #right {
        display: none;
    }
    #right-mobile {
        display: block;
    }
    #menu-close-icon {
        background-image: url(../assets/menu-close@2x.png);
        width: 24px;
        height: 24px;
        background-size: cover;
        float: right;
        margin-right: 10px;
        margin-top: 10px;
    }
    #menu-icon {
        background-image: url(../assets/menu@2x.png);
        width: 24px;
        height: 24px;
        background-size: cover;
        float: right;
        margin-right: 10px;
        margin-top: 10px;
    }
    .mobile-menu {
        font-weight: 600;
        position: fixed;
        z-index: 1;
        width: 80%;
        height: 100%;
        background-color: black;
        padding: 10%;
        overflow: scroll;
        height: 100%;
        height: calc(100vh - 86px);
        padding-bottom: 0;
        padding-top: 0;
    }
    .mobile-menu h4,
    .mobile-menu > div > a,
    .mobile-menu p,
    .mobile-menu > div > div a {
        color: white;
    }
    .mobile-menu hr {
        border-color: black;
    }
    .mobile-menu-link {
        font-weight: normal;
    }
    .mobile-menu a {
        display: block;
        text-align: left;
    }
    .mobile-menu > div a {
        margin-top: 10px;
    }
    .mobile-menu > p > span.menu {
        float: right;
        width: 12px;
        height: 9px;
        margin-top: 7px;
        vertical-align: middle;
        display: inline-block;
        background-size: cover;
    }
    .mobile-menu > p > span.menu-open {
        background-image: url(../assets/ic-keyboard-arrow-up-24-px@2x.png);
    }
    .mobile-menu > p > span.menu-close {
        background-image: url(../assets/ic-keyboard-arrow-down-24-px@2x.png);
    }
}

// New login panel and user menu
.user-menu {
    width: 260px;
    height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue